/**
 * Agent domain models for the web-app.
 *
 * The request/response shapes are the GENERATED, OpenAPI-derived types from the
 * `@workgraph/actor-service-web-client` package — they are re-exported here (never
 * re-declared) so components consume contract-versioned, type-safe models that can never
 * drift from the actor-service.
 */
export type {
    AgentResponse as Agent,
    CreateAgentRequest,
    UpdateAgentRequest,
    AgentListResponse,
    ErrorResponse,
} from '@workgraph/actor-service-web-client';

/**
 * A selectable compute profile for an agent.
 *
 * There is no "list runtimes" backend endpoint today, so the choices are config-only. The
 * `id` is sent verbatim as `runtimeId` in the generated create/update requests.
 */
export interface RuntimeChoice {
    id: string;
    label: string;
}

export const RUNTIME_CHOICES: RuntimeChoice[] = [
    { id: 'rt-standard', label: 'Standard' },
    { id: 'rt-heavy', label: 'Heavy (high compute)' },
    { id: 'rt-lightweight', label: 'Lightweight' },
];

export const DEFAULT_RUNTIME_ID = 'rt-standard';

/**
 * Resolve a runtime id to its human-readable label, falling back to the raw id when it is
 * not one of the known config choices (e.g. an older/unknown runtime returned by the API).
 */
export function runtimeLabel(id: string): string {
    return RUNTIME_CHOICES.find((choice) => choice.id === id)?.label ?? id;
}
